import { useContext } from 'react';
import clsx from 'clsx';

import WorkOrderFields from '@atom/components/common/workOrderDetail/workOrderFields/WorkOrderFields';
import WorkOrderPreviewContext, {
  ExpandedInfo,
  WorkOrderActionTypes,
} from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { Icon, IconButton } from '@atom/mui';
import { ExpandLessIcon, ExpandMoreIcon } from '@atom/mui/icons';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import classes from './infoView.module.css';

const CustomSection = () => {
  const { expandedInfo, setExpandedInfo, workOrderDetail, dispatch, refetch } =
    useContext(WorkOrderPreviewContext);

  const toggleSection = () => {
    setExpandedInfo(toggleFromSet(expandedInfo, ExpandedInfo.CUSTOM));
  };

  const icon = expandedInfo.has(ExpandedInfo.CUSTOM)
    ? ExpandLessIcon
    : ExpandMoreIcon;

  return (
    <>
      <div className={classes.sectionHeader}>
        <div className={classes.sectionTitle}>Custom Fields Section</div>
        <IconButton onClick={toggleSection}>
          <Icon icon={icon} />
        </IconButton>
      </div>
      {expandedInfo.has(ExpandedInfo.CUSTOM) && (
        <div className={clsx(classes.sectionContent, classes.custom)}>
          <WorkOrderFields
            workOrderDetail={workOrderDetail}
            dispatch={dispatch}
            WorkOrderActionTypes={WorkOrderActionTypes}
            refetch={refetch}
          />
        </div>
      )}
    </>
  );
};

export default CustomSection;
